module.exports = __webpack_public_path__ + "img/game.e5e952.svg";